<!--
 * @Author: mazhigang
 * @Date: 2023-07-03 17:43:22
 * @LastEditors: mazhigang
 * @LastEditTime: 2024-01-31 13:15:14
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>证件级别配置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">证件级别配置</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="证件类型">
                  <el-select
                    v-model="ruleForm.name"
                    placeholder="请选择证件类型"
                    style="margin-right: auto"
                  >
                    <el-option
                      :label="item.title"
                      :value="item.lvKey"
                      v-for="(item, index) in tableData"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-button
          type="primary"
          class="btn"
          style="margin-bottom: 16px"
          @click="add()"
          >添加</el-button
        >
        <el-table ref="scrollTable" :data="tableData1" style="width: 100%">
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column prop="propDesc" label="证件级别" align="center">
          </el-table-column>
          <el-table-column label="级别值" align="center" prop="propValue">
          </el-table-column>
          <el-table-column label="排序" align="center" prop="sort">
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            label="发布时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <div class="disAround">
                <div class="operateBtn" @click="handleEdit(scope.row)">
                  编辑
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="deleteItem(scope.row)"
                >
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination> -->
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="600px">
      <el-form
        label-position="right"
        :model="ruleForm1"
        :rules="rules"
        ref="ruleForm"
        style="margin: 0 auto"
      >
        <el-form-item label="级别名称" prop="name">
          <el-input
            v-model="ruleForm1.name"
            placeholder="请输入级别名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="级别值" prop="num">
          <el-input
            v-model="ruleForm1.num"
            placeholder="请输入级别值"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input
            v-model="ruleForm1.sort"
            placeholder="请输入排序"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm1('ruleForm')">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      ruleForm: {
        name: "",
      },
      tableData: [],
      tableData1: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      title: "",
      editId: "",
      ruleForm1: {
        sort: "",
        num: "",
        name: "",
      },
      rules: {
        sort: [{ required: true, message: "必选项", trigger: "blur" }],
        num: [{ required: true, message: "必选项", trigger: "blur" }],
        name: [{ required: true, message: "必选项", trigger: "blur" }],
        status: [{ required: true, message: "必选项", trigger: "change" }],
      },
    };
  },
  mounted() {
    this.getData();
    if (this.$route.query.lvKey) {
      this.ruleForm.name = this.$route.query.lvKey;
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            propName: this.ruleForm.name,
            propDesc: this.ruleForm1.name,
            propValue: this.ruleForm1.num,
            sort: this.ruleForm1.sort,
          };
          if (this.editId == "") {
            this.$axios
              .post(`/admapi/sys/conf/add`, param)
              .then(({ data }) => {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.getList();
              })
              .catch()
              .finally(() => {
                this.dialogFormVisible = false;
                this.ruleForm1.num = "";
                this.ruleForm1.sort = "";
                this.ruleForm1.name = "";
              });
          } else {
            this.$axios
              .post(`/admapi/sys/conf/update/${this.editId}`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.getList();
              })
              .catch()
              .finally(() => {
                this.dialogFormVisible = false;
                this.editId = "";
                this.ruleForm1.num = "";
                this.ruleForm1.status = "";
                this.ruleForm1.sort = "";
                this.ruleForm1.name = "";
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm1(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    add() {
      this.title = "新增级别";
      this.editId = "";
      this.dialogFormVisible = true;
    },
    handleEdit(val) {
      this.editId = val.id;
      this.title = "编辑级别";
      this.ruleForm1.sort = val.sort;
      this.ruleForm1.num = val.propValue;
      this.ruleForm1.name = val.propDesc;
      this.dialogFormVisible = true;
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: 1,
        pageSize: 99999,
        queryParams: [
          {
            name: "prop_name",
            type: "input",
            value: this.ruleForm.name,
          },
        ],
      };
      this.$axios
        .post(`/admapi/sys/conf/list`, param)
        .then(({ data }) => {
          this.tableData1 = data.items;
        })
        .catch()
        .finally();
    },
    getData() {
      let param = {
        page: 1,
        pageSize: 99999,
        queryParams: [
          {
            name: "prop_name",
            type: "input",
            value: "pricePremiumType_certs",
          },
        ],
      };
      this.$axios
        .post(`/admapi/sys/conf/list`, param)
        .then(({ data }) => {
          this.tableData = JSON.parse(data.items[0].propValue);
          this.getList();
        })
        .catch()
        .finally();
    },
    deleteItem(val) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`/admapi/sys/conf/del`, {
              id: val.id,
              propName: this.ruleForm.name,
            })
            .then(({ data }) => {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped></style>
